// Copyright (c) Docugami, Inc. All rights reserved.**/

import styled from "styled-components";

const getMaxWidthMediaQuery = (maxWidth?: number) => {
    if (maxWidth !== undefined) {
        return (
            `@media only screen and (max-width: ${maxWidth}px) {
                display: none;
            }`
        );
    }

    return ''
}

const getMinWidthMediaQuery = (minWidth?: number) => {
    if (minWidth !== undefined) {
        return (
            `@media only screen and (min-width: ${minWidth}px) {
                display: none;
            }`
        );
    }

    return ''
}

export const RestrictedScreenView = styled.div<{ minWidth?: number, maxWidth?: number }>`
    ${props => getMinWidthMediaQuery(props.minWidth)}
    ${props => getMaxWidthMediaQuery(props.maxWidth)}
    display: inherit;
    gap: inherit;
`
